// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__89lOh","footer":"ModalCreateQualiphyProcedure_footer__DCPJ4","additionData":"ModalCreateQualiphyProcedure_additionData__1pnu3"};